<div mat-dialog-content class="form-container" style="position: relative;">
  <div fxLayout="column">
    <mat-form-field appearance="fill">
      <mat-label>Comunidad</mat-label>
      <mat-select [(ngModel)]="idcomunidad" (selectionChange)="setComm($event)">
        <mat-option *ngFor="let comm of comunidades" [value]="comm.id">
          {{comm.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div ng2FileDrop
          (click)="fileInput.click()"
          [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
          (fileOver)="fileOverBase($event)"
          [uploader]="uploader"
          class="well my-drop-zone">
      <p>Pulse o arrastre los ficheros aquí</p>
    </div>
    <div *ngIf="uploader.queue.length > 0">
      <div class="file" *ngFor="let item of uploader.queue">
        <div class="file-header">
          <strong>{{item.file.name}}</strong>
          <button mat-icon-button color="warn" (click)="item.remove()" title="Eliminar">
              <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- Contenedor para la vista previa -->
        <div *ngIf="item.previewContent" class="preview-container">
          <pre style="margin: 0;">{{ item.previewContent }}</pre>
        </div>
      </div>
    </div>
    <button *ngIf="!uploading" mat-raised-button (click)="upload()">Importar</button>
    <input type="file" #fileInput style="display: none; height: 0px;" ng2FileSelect [uploader]="uploader"/>
    <button *ngIf="uploading" mat-raised-button disabled>Importando</button>
  </div>
  
  <!-- Overlay del spinner -->
  <div *ngIf="uploading" class="spinner">
    <mat-spinner diameter="50"></mat-spinner>
    <p style="margin-top: 20px; font-size: 16px; font-weight: 500;">Procesando solicitudes...</p>
  </div>
</div>
